import { defineStore } from "pinia";

export const useToastStore = defineStore("toast", {
  state: () => ({
    show: false,
    message: "",
    severity: "success",
    params: {},
  }),
  actions: {
    triggerToast({ message, severity = "success", params = {} }) {
      this.message = message;
      this.severity = severity;
      this.params = params;
      this.show = true;
    },
    clearToast() {
      this.show = false;
      this.message = "";
      this.severity = "success";
      this.params = {};
    },
  },
});
